import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import {
  LockOpen,
  Lock,
  SwapVert,
  History
} from '@mui/icons-material';

const CashRegisterMenuDialog = ({
  open,
  onClose,
  isCashOpen,
  onOpenClose,
  onTransfer,
  onHistory
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Gestione Cassa</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Seleziona l&apos;operazione da effettuare.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Button
          variant="contained"
          color={isCashOpen ? 'warning' : 'success'}
          startIcon={isCashOpen ? <Lock /> : <LockOpen />}
          onClick={onOpenClose}
          fullWidth
          sx={{ justifyContent: 'flex-start', py: 1.2 }}
        >
          {isCashOpen ? 'Chiusura cassa' : 'Apertura cassa'}
        </Button>
        {isCashOpen && (
          <>
            <Button
              variant="outlined"
              color="warning"
              startIcon={<SwapVert />}
              onClick={() => onTransfer('PRELIEVO')}
              fullWidth
              sx={{ justifyContent: 'flex-start', py: 1.2 }}
            >
              Prelievo (cassa → cassaforte)
            </Button>
            <Button
              variant="outlined"
              color="info"
              startIcon={<SwapVert />}
              onClick={() => onTransfer('VERSAMENTO')}
              fullWidth
              sx={{ justifyContent: 'flex-start', py: 1.2 }}
            >
              Versamento (cassaforte → cassa)
            </Button>
          </>
        )}
        <Button
          variant="outlined"
          startIcon={<History />}
          onClick={onHistory}
          fullWidth
          sx={{ justifyContent: 'flex-start', py: 1.2 }}
        >
          Storico chiusure cassa
        </Button>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Annulla</Button>
    </DialogActions>
  </Dialog>
);

export default CashRegisterMenuDialog;
